var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.125H17H19.82C21.5763 1.125 23 2.54873 23 4.305V7.125V12.125V17.125V19.945C23 21.7013 21.5763 23.125 19.82 23.125H17H7H4.18C2.42373 23.125 1 21.7013 1 19.945V17.125V12.125V7.125V4.305C1 2.54873 2.42373 1.125 4.18 1.125H7ZM21 6.125V4.305C21 3.6533 20.4717 3.125 19.82 3.125H18V6.125H21ZM18 8.125H21V11.125H18V8.125ZM16 7.125V3.125H8V7.125V11.125H16V7.125ZM21 13.125V16.125H18V13.125H21ZM21 18.125H18V21.125H19.82C20.4717 21.125 21 20.5967 21 19.945V18.125ZM16 13.125V17.125V21.125H8V17.125V13.125H16ZM3 18.125V19.945C3 20.5967 3.5283 21.125 4.18 21.125H6V18.125H3ZM6 16.125H3V13.125H6V16.125ZM3 11.125V8.125H6V11.125H3ZM3 6.125H6V3.125H4.18C3.5283 3.125 3 3.6533 3 4.305V6.125Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5125_13340",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.125H17H19.82C21.5763 1.125 23 2.54873 23 4.305V7.125V12.125V17.125V19.945C23 21.7013 21.5763 23.125 19.82 23.125H17H7H4.18C2.42373 23.125 1 21.7013 1 19.945V17.125V12.125V7.125V4.305C1 2.54873 2.42373 1.125 4.18 1.125H7ZM21 6.125V4.305C21 3.6533 20.4717 3.125 19.82 3.125H18V6.125H21ZM18 8.125H21V11.125H18V8.125ZM16 7.125V3.125H8V7.125V11.125H16V7.125ZM21 13.125V16.125H18V13.125H21ZM21 18.125H18V21.125H19.82C20.4717 21.125 21 20.5967 21 19.945V18.125ZM16 13.125V17.125V21.125H8V17.125V13.125H16ZM3 18.125V19.945C3 20.5967 3.5283 21.125 4.18 21.125H6V18.125H3ZM6 16.125H3V13.125H6V16.125ZM3 11.125V8.125H6V11.125H3ZM3 6.125H6V3.125H4.18C3.5283 3.125 3 3.6533 3 4.305V6.125Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5125_13340)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilm);
export default __webpack_public_path__ + "static/media/film.215b85a8c7dc972e45acd7a523dc1887.svg";
export { ForwardRef as ReactComponent };